import { defineComponent as i, openBlock as a, createBlock as u, unref as d, normalizeClass as r, withCtx as t, createVNode as f, normalizeStyle as h, renderSlot as l, createElementBlock as n, createCommentVNode as c } from "vue";
import "./ghl-ui.es185.js";
import k from "./ghl-ui.es186.js";
import w from "./ghl-ui.es187.js";
const y = {
  key: 0,
  class: "hl-modal-border-div header-border"
}, b = {
  key: 1,
  class: "hl-modal-border-div footer-border"
}, B = i({
  name: "UIModal",
  inheritAttrs: !1
}), C = i({
  ...B,
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      default: 544
    },
    zIndex: {
      type: Number,
      default: void 0
    },
    to: {
      type: [String, HTMLElement],
      default: void 0
    },
    autoFocus: {
      type: Boolean,
      default: !1
    },
    className: {
      type: String,
      default: ""
    },
    maskClosable: {
      type: Boolean,
      default: !0
    },
    showBorder: {
      type: Boolean,
      default: !1
    },
    closeOnEsc: {
      type: Boolean
    }
  },
  emits: ["update:show", "onEsc", "onMaskClick"],
  setup(e) {
    return (o, s) => (a(), u(d(k), {
      show: e.show,
      "onUpdate:show": s[0] || (s[0] = (m) => o.$emit("update:show", m)),
      "z-index": e.zIndex,
      "auto-focus": e.autoFocus,
      to: e.to,
      "mask-closable": e.maskClosable,
      class: r([e.showBorder ? "hl-modal-border" : ""]),
      "close-on-esc": e.closeOnEsc,
      "on-esc": () => o.$emit("onEsc"),
      "on-mask-click": () => o.$emit("onMaskClick")
    }, {
      default: t(() => [
        f(d(w), {
          style: h({ width: `${e.width}px` }),
          bordered: !1,
          size: "huge",
          role: "dialog",
          "aria-modal": "true",
          class: r(["hl-modal", e.className])
        }, {
          header: t(() => [
            l(o.$slots, "header")
          ]),
          footer: t(() => [
            l(o.$slots, "footer")
          ]),
          default: t(() => [
            e.showBorder ? (a(), n("div", y)) : c("", !0),
            l(o.$slots, "default"),
            e.showBorder ? (a(), n("div", b)) : c("", !0)
          ]),
          _: 3
        }, 8, ["style", "class"])
      ]),
      _: 3
    }, 8, ["show", "z-index", "auto-focus", "to", "mask-closable", "class", "close-on-esc", "on-esc", "on-mask-click"]));
  }
}), E = C;
export {
  E as default
};
